import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'progress'
})
export class ProgressPipe implements PipeTransform {
  transform(activeIndex: number, total: number): number {
    return ((activeIndex + 1) / total) * 100;
  }
}
